{
  "charts": {
    "dateLabel": "Fecha: {{date}}",
    "completion": {
      "title": "Tasa de finalización por curso",
      "description": "Cursos con mejor rendimiento",
      "overallAverage": "Media general",
      "levels": {
        "excellent": "Excelente",
        "good": "Buena",
        "fair": "Regular",
        "low": "Baja"
      },
      "tooltipLabel": "Tasa de finalización",
      "tooltipDetail": "{{completed}} de {{total}} inscripciones completadas",
      "legend": {
        "excellent": "Excelente (≥80%)",
        "good": "Buena (60-79%)",
        "fair": "Regular (40-59%)",
        "low": "Baja (<40%)"
      }
    },
    "engagement": {
      "title": "Métricas de interacción",
      "description_one": "Actividad diaria del último {{count}} día",
      "description_zero": "Actividad diaria de los últimos {{count}} días",
      "description_other": "Actividad diaria de los últimos {{count}} días",
      "uniqueUsers": "Usuarios únicos",
      "sessions": "Sesiones",
      "pageViews": "Visualizaciones"
    },
    "retention": {
      "loadingTitle": "Análisis de retención",
      "title": "Análisis de retención de usuarios",
      "description": "Tasa de retención por cohorte en los últimos 10 días",
      "newUsers": "Nuevos usuarios",
      "day": "Día {{day}}",
      "retentionDay": "Retención día {{day}}"
    }
  },
  "tabs": {
    "overview": "Visión general",
    "students": "Alumnos",
    "lessons": "Clases",
    "payments": "Pagos",
    "courses": "Cursos"
  },
  "paymentStatus": {
    "paid": "Pagado",
    "refunded": "Reembolsado",
    "chargeback": "Contracargo",
    "pending": "Pendiente",
    "cancelled": "Cancelado"
  },
  "paymentMethods": {
    "creditCard": "Tarjeta",
    "debitCard": "Débito",
    "pix": "PIX",
    "boleto": "Boleto",
    "bankTransfer": "Transf."
  },
  "page": {
    "title": "Panel",
    "subtitle": "Visión completa de la plataforma",
    "loading": "Cargando panel...",
    "loadError": "Error al cargar los datos del panel",
    "realTime": "Tiempo real"
  },
  "stats": {
    "totalRevenue": "Ingresos totales",
    "monthlyRevenue": "Ingresos mensuales",
    "averageTicket": "Ticket medio",
    "averageTicketSub": "Valor medio por venta",
    "users": "Usuarios",
    "activeCourses": "Cursos activos",
    "completion": "Finalización de clases",
    "refund": "Reembolso",
    "chargeback": "Contracargos",
    "refundChargeback": "Reembolso / Contracargo",
    "chargebackSub": "Contracargos: {{rate}}%",
    "salesCount_one": "{{count}} venta",
    "salesCount_zero": "{{count}} ventas",
    "salesCount_other": "{{count}} ventas",
    "salesThisMonth_one": "{{count}} venta este mes",
    "salesThisMonth_zero": "{{count}} ventas este mes",
    "salesThisMonth_other": "{{count}} ventas este mes",
    "enrollmentsCount_one": "{{count}} inscripción",
    "enrollmentsCount_zero": "{{count}} inscripciones",
    "enrollmentsCount_other": "{{count}} inscripciones"
  },
  "series": {
    "revenue": "Ingresos",
    "refunds": "Reembolsos",
    "sales": "Ventas",
    "enrollments": "Inscripciones",
    "completions": "Finalizaciones",
    "amount": "Importe"
  },
  "overview": {
    "monthlyRevenueTitle": "Ingresos mensuales (12 meses)",
    "salesPerMonth": "Ventas por mes",
    "enrollmentsVsCompletions": "Inscripciones vs finalizaciones",
    "coursesByCategory": "Cursos por categoría",
    "topCourses": "Cursos top",
    "studentsCount_one": "{{count}} alumno",
    "studentsCount_zero": "{{count}} alumnos",
    "studentsCount_other": "{{count}} alumnos",
    "noCourses": "No se encontraron cursos",
    "noCategories": "Ninguna categoría"
  },
  "payments": {
    "methods": "Métodos de pago",
    "noSalesRecorded": "No hay ventas registradas",
    "recentSales": "Ventas recientes",
    "noSalesYet": "Todavía no hay ventas",
    "noSalesYetDescription": "Las ventas aparecerán aquí cuando se procesen",
    "revenueAndSalesTitle": "Ingresos y ventas (12 meses)"
  },
  "students": {
    "unavailable": "Datos de alumnos no disponibles",
    "enrollmentStatus": {
      "active": "Activas",
      "expired": "Caducadas",
      "cancelled": "Canceladas"
    },
    "total": "Total de alumnos",
    "newThisMonth_one": "{{count}} nuevo este mes",
    "newThisMonth_zero": "{{count}} nuevos este mes",
    "newThisMonth_other": "{{count}} nuevos este mes",
    "newToday": "Nuevos hoy",
    "thisWeek_one": "{{count}} esta semana",
    "thisWeek_zero": "{{count}} esta semana",
    "thisWeek_other": "{{count}} esta semana",
    "dau": "Usuarios activos (DAU)",
    "withEnrollments": "Con inscripciones",
    "ofTotal": "{{rate}}% del total",
    "verifiedEmails": "Emails verificados",
    "withCompletions": "Con finalizaciones",
    "completionRate": "Alumnos con finalización",
    "newPerDayTitle": "Nuevos alumnos por día (30 días)",
    "newStudents": "Nuevos alumnos",
    "enrollmentsByStatus": "Inscripciones por estado",
    "noEnrollments": "No hay inscripciones registradas",
    "activeUsers": "Usuarios activos",
    "activeToday": "Activos hoy",
    "activeTodaySub": "Usuarios únicos en las últimas 24 h",
    "activeWeek": "Activos esta semana",
    "activeWeekSub": "Usuarios únicos en los últimos 7 días",
    "activeMonth": "Activos este mes",
    "activeMonthSub": "Usuarios únicos en los últimos 30 días",
    "engagement": "Interacción (activos hoy / activos este mes)",
    "recentEnrollments": "Inscripciones recientes",
    "noRecentEnrollments": "No hay inscripciones recientes"
  },
  "lessons": {
    "unavailable": "Datos de clases no disponibles",
    "total": "Total de clases",
    "started_one": "{{count}} iniciada",
    "started_zero": "{{count}} iniciadas",
    "started_other": "{{count}} iniciadas",
    "completed": "Clases completadas",
    "completionRate": "{{rate}}% de finalización",
    "watchedWeek": "Vistas (semana)",
    "thisMonth_one": "{{count}} este mes",
    "thisMonth_zero": "{{count}} este mes",
    "thisMonth_other": "{{count}} este mes",
    "averageProgress": "Progreso medio",
    "sessions_one": "{{count}} sesión",
    "sessions_zero": "{{count}} sesiones",
    "sessions_other": "{{count}} sesiones",
    "activityTitle": "Actividad de clases por día (30 días)",
    "watched": "Vistas",
    "completedSeries": "Completadas",
    "mostWatched": "Clases más vistas",
    "views": "vistas",
    "completions": "completadas",
    "noneWatched": "Ninguna clase vista",
    "recentCompleted": "Últimas clases completadas"
  },
  "courses": {
    "published": "Cursos publicados",
    "inDevelopment_one": "{{count}} en desarrollo",
    "inDevelopment_zero": "{{count}} en desarrollo",
    "inDevelopment_other": "{{count}} en desarrollo",
    "totalEnrollments": "Total de inscripciones",
    "completionRate": "Finalización de cursos",
    "categories": "Categorías",
    "performance": "Rendimiento por curso",
    "modules_one": "{{count}} módulo",
    "modules_zero": "{{count}} módulos",
    "modules_other": "{{count}} módulos",
    "enrollments": "inscripciones",
    "active": "activas",
    "completed": "completadas",
    "progress": "progreso",
    "completion": "finalización",
    "noPublished": "No hay cursos publicados",
    "categoryDistribution": "Distribución por categoría",
    "completionByCourse": "Tasa de finalización por curso",
    "recentCompletions": "Últimas finalizaciones de curso"
  }
}
